import { SideNav, SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { HR } from 'foundations-components/transitional/components/HR';
import { ShinySkeletonText } from '../helpers/ShinySkeletonText';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UniversalAssociationsSelectSideNavSkeleton = () => {
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    paddingBlockStart: "200",
    paddingBlockEnd: "200",
    paddingInlineStart: "300",
    inlineSize: "160px",
    minInlineSize: "160px",
    overflowY: "scroll",
    borderInlineEndWidth: "100",
    borderInlineEndStyle: "solid",
    borderInlineEndColor: "border-core-default",
    children: [/*#__PURE__*/_jsx(SideNav, {
      "aria-label": "Selected Associations Skeleton",
      marginBlockEnd: "0",
      marginBlockStart: "0",
      children: /*#__PURE__*/_jsx(SideNavItem, {
        active: true,
        title: /*#__PURE__*/_jsx(ShinySkeletonText, {}),
        count: /*#__PURE__*/_jsx(ShinySkeletonText, {
          width: 15
        })
      })
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(SideNav, {
      "aria-label": "Other Associations Skeleton",
      marginBlockEnd: "0",
      marginBlockStart: "100",
      children: Array.from({
        length: 5
      }, (_, index) => /*#__PURE__*/_jsx(SideNavItem, {
        title: /*#__PURE__*/_jsx(ShinySkeletonText, {}),
        count: /*#__PURE__*/_jsx(ShinySkeletonText, {
          width: 15
        })
      }, index))
    })]
  });
};